import React from 'react';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { ModalFormButton } from 'framework/form';
import useAssessmentService, { CREATE_ASSESSMENT } from '../../assessmentService';
import AssessmentForm from '../../createupdate/AssessmentForm';
import { ListItem, useListContext } from 'framework/list';
import { useAuthorization } from 'framework/authorization';
import { useIsMyProfile } from 'domain/shared/employee';

const EditAssessmentButton = ({ source }: FieldProps) => {
  const isMyProfile = useIsMyProfile();
  const { isGranted } = useAuthorization();
  const { update, getById, getValidationSchema } = useAssessmentService();
  const { getValue } = useFieldHelper({ source });
  const { updateInList = (entity: ListItem) => {} } = useListContext();

  const id = getValue();

  if (!isGranted(CREATE_ASSESSMENT) || isMyProfile) {
    return null;
  }

  return (
    <ModalFormButton
      formTitle="Edit assessment"
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        message: 'You are awesome! The Assessment has been successfully updated.',
        execute: (response: any) => {
          updateInList(response);
        },
      }}
      color="transparent"
      label={<AppRegistrationIcon color="primary" />}
      submitFormFunc={data => update(id, data)}
      getDataFunc={() => getById(id)}
      modalSize="sm"
      paperStyles={{
        background: 'var(--mui-palette-background-paper)',
      }}
      sxButton={{
        minWidth: 'auto',
        p: 0,
      }}
    >
      <AssessmentForm />
    </ModalFormButton>
  );
};

export default EditAssessmentButton;
